import 'moment/locale/fr';
import moment from 'moment';

export const formatNumber = (num, locale) => {
  return num.toLocaleString(locale);
};

export const formatTime = (date, lang) => {
  const localizedMoment = moment(date).locale(lang);
  let formattedDate =
    lang === 'fr'
      ? localizedMoment.format('D MMM YYYY, HH:mm [UTC]ZZ')
      : localizedMoment.format('MMM D YYYY, h:mm A [UTC]ZZ');
  return formattedDate;
};



// WEBPACK FOOTER //
// ./src/helpers/formatters.js